import { TrophyOutlined } from '@ant-design/icons';
import './ranking-card.css';
import { Card, Typography, Badge, Spin } from 'antd';
import { RatingDto } from '../../dto/reporting-models';
const { Text } = Typography;

type TeamRankingCardProps = {
  title: string;
  rankData: RatingDto | null;
  total: string;
  loading?: boolean;
};

const colors = ['var(--color-gold)', 'var(--color-silver)', 'var(--color-bronze)']; // Gold, Silver, Bronze

const TeamRankingCard = ({ title, rankData, total, loading = false }: TeamRankingCardProps) => {
  const getBadgeIcon = (index: number) => {
    if (index < 3) {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TrophyOutlined style={{ color: getBadgeColor(index), fontSize: '20px' }} />
        </div>
      );
    }
    return (
      <div style={{ display: 'flex' }}>
        <Badge count={index + 1} style={{ backgroundColor: 'var(--badge-bg)', color: 'var(--badge-text)', fontWeight: '600' }} />
      </div>
    );
  };

  const getBadgeColor = (index: number): string => {
    return colors[index] || 'var(--text-secondary)';
  };

  return (
    <Card className="ranking-card">
      <Spin spinning={loading}>
        <div className="callers-list">
          <div className="position-rank" style={{ backgroundColor: 'var(--rank-bg)', color: 'var(--btn-text-on-colored)' }}>
            <div style={{ marginLeft: '15px', display: 'flex', flex: 1, overflow: 'hidden' }}>
              <div style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={title}>
                {title}
              </div>
            </div>
            <div style={{ marginRight: '20px' }}>{total}</div>
          </div>
          {rankData?.leaderboard?.slice().map((item, index) => (
            <div key={index?.toString()} className="caller-item">
              <div style={{ marginLeft: '15px', display: 'flex', flex: 1, overflow: 'hidden' }}>
                {getBadgeIcon(index)}
                <Text
                  strong
                  ellipsis={{ tooltip: item.fullName }}
                  style={{
                    marginLeft: '10px',
                    marginRight: '20px',
                    fontSize: '15px',
                    flex: 1,
                    overflow: 'hidden',
                  }}
                >
                  {item.fullName}
                </Text>
              </div>
              <Text style={{ marginRight: '20px' }}>{item.count}</Text>
            </div>
          ))}
        </div>
      </Spin>
    </Card>
  );
};

export default TeamRankingCard;
